import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import alertify from "alertifyjs";
import "../../../node_modules/alertifyjs/build/css/alertify.css";
import "../../../node_modules/alertifyjs/build/css/themes/semantic.css";
import ApiService from "../../service/httpService";

const Addcompany = ({ fetchEmployees,Data }) => {

  const [eye, seteye] = useState(true);
  const cancelBtnRef = useRef(null);
  const [Emp, setEmp] = useState([]);
  const [LocationData,setLocationData]=useState([])
  const [fullEmpData, SetfullEmpData] = useState([])

  const [formData, setFormData] = useState({
    name: "",
    date_of_birth: "",
    emp_type: "",
    user_type: "",
    incharge: "",
    blood_group: "",
    department: "",
    mobile_no: "",
    password: "",
    doj: "",
    shift_in: "",
    shift_out: "",
    location: "",
    stay: "",
    salary: "",
    con_person: "",
    cont_no: "",
    relationship: "",
    status:"1",
  });

  useEffect(() => {
    SetfullEmpData(Data)
  },[Data])

  const [validation, setValidation] = useState({
    name: true,
    date_of_birth: true,
    blood_group: true,
    emp_type: true,
    user_type: true,
    department: true,
    mobile_no: true,
    password: true,
    doj: true,
    stay: true,
    salary: true,
    con_person: true,
    cont_no: true,
    relationship: true,
    shift_in: true,
    shift_out: true,
    incharge: true,
    location: true,
    status: true,
  });


  const onEyeClick = () => {
    seteye(!eye);
  };


  const location = async () => {
    try {
      const res = await ApiService.getPublic(`get_data.php?table=location&authToken=`);
      console.log("Location 1", res);
      const locations = res.filter((item) => item.status == '1');
      console.log("Location 2", locations);
      setLocationData(locations);

    } catch (err) {
      console.log("error on fetchEmployees", err);
    }
  };

  const triggerCancel = () => {
    // This will simulate a click on the button
    if (cancelBtnRef.current) {
      cancelBtnRef.current.click();
    }
  };


  //age is under 18 validation
  const isAgeAbove18 = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();

    const age = today.getFullYear() - birthDate.getFullYear();
    const hasHadBirthdayThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() >= birthDate.getDate());

    const actualAge = hasHadBirthdayThisYear ? age : age - 1;

    return actualAge >= 18;
  };

  //trim input before submiting
  const trimformData = (data) => {
    const trimmedData = {};

    Object.keys(data).forEach((key) => {
      const value = (data)[key];
      trimmedData[key] = typeof value === "string" ? value.trim() : value;
    });

    return trimmedData;
  };

  //valid datation
  useEffect(() => {
    for (const key in formData) {
      const value = formData[key];
      if (
        value !== undefined &&
        value !== null &&
        value.toString().trim() !== ""
      ) {
        setValidation((prev) => ({ ...prev, [key]: true }));
      }
    }
  }, [formData]);

  const HandleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted form data:", formData);

    let Isvalid = true;
    let isEmpty = false;

    for (const key in formData) {
      if (key == 'department' || key == 'stay' || key == 'shift_in'  || key == 'shift_out' ) {
        continue;
      }
      console.log(key);
      if (key == 'incharge') {
        if (formData.user_type == 'admin') {
          continue;
        }
      }
      const value = formData[key];
      if (
        value === undefined ||
        value === null ||
        value.toString().trim() === ""
      ) {
        console.log(key);
        
        Isvalid = false;
        isEmpty = true;
        setValidation((prev) => ({ ...prev, [key]: false }));
      }
    }

   let inValidMobile=false
 for (let emp of fullEmpData) {
  if (emp.mobile==formData.mobile_no) {
    Isvalid = false;
    inValidMobile = true;
    setValidation((prev) => ({ ...prev, mobile_no: false }));
    break; // Optional, stops after finding first match
  }
}

    alertify.set("notifier", "position", "top-right");

    if (isEmpty) {
      alertify.error("Please fill all required fields.");
      return;
    }

    else if (inValidMobile) {
      alertify.error("mobile number already register");
    }

    else if (!isAgeAbove18(formData["date_of_birth"])) {
      Isvalid = false;
      setValidation((prev) => ({ ...prev, ["date_of_birth"]: false }));
      alertify.error("Employee must be at least 18 years old.");
      return;
    }

    else if (!(/^\d{10}$/.test(formData["mobile_no"].toString().trim()))) {
      Isvalid = false;
      setValidation((prev) => ({ ...prev, mobile_no: false }));
      alertify.error("Enter a valid 10-digit mobile number starting with 6-9.");
      return;
    }

    else if (!(/^\d{10}$/.test(formData["cont_no"].toString().trim()))) {
      Isvalid = false;
      setValidation((prev) => ({ ...prev, cont_no: false }));
      alertify.error("Enter a valid 10-digit emergency contact number.");
      return;
    }
      
 else if (formData["password"].toString().trim().length < 6) {
  Isvalid = false;
  setValidation((prev) => ({ ...prev, password: false }));
  alertify.error("Password must be at least 6 characters long.");
  return;
}

    else if (
      formData["mobile_no"].toString().trim() ===
      formData["cont_no"].toString().trim()
    ) {
      Isvalid = false;
      setValidation((prev) => ({ ...prev, ["cont_no"]: false }));
      alertify.error("Mobile number and emergency contact cannot be the same.");
      return;
    }


    const trimedData = trimformData(formData);

    if (Isvalid) {
      ApiService.postPublic(
          `post_insert_data.php?table=employee&authToken=`,
          trimedData
        )
        .then((data) => {
          if (data.status === "success") {
            console.log("Submission success:", data);
            alertify.success("Employee added successfully!");
            resetForm();
            triggerCancel();
            fetchEmployees();
          } else {
            console.log("Submit error");
            alertify.error("Failed to submit. Please try again.");
          }
        })
        .catch((error) => {
          resetForm();
          console.error("Submission failed:", error);
          alertify.error("Something went wrong. Please try again.");
        });
    }
  };


  //reset value
  const resetForm = () => {
    setFormData({
      name: "",
      date_of_birth: "",
      emp_type: "",
      user_type: "",
      incharge: "",
      blood_group: "",
      department: "",
      mobile_no: "",
      password: "",
      doj: "",
      shift_in: "",
      shift_out: "",
      location: '',
      stay: "",
      salary: "",
      con_person: "",
      cont_no: "",
      relationship: "",
      status:"1",
    });

    setValidation({
      name: true,
      date_of_birth: true,
      blood_group: true,
      emp_type: true,
      user_type: true,
      department: true,
      mobile_no: true,
      password: true,
      doj: true,
      stay: true,
      salary: true,
      con_person: true,
      cont_no: true,
      relationship: true,
      shift_in: true,
      shift_out: true,
      incharge: true,
      location: true,
      status: true,
    });
  };

  //form reset
  useEffect(() => {
    location()
    formData.user_type&&fetchFilteredEmployees(formData.user_type)
  }, [Data]);


const handleUserTypeChange = (e) => {
  const selectedUserType = e.target.value;
  setFormData((prevState) => ({ ...prevState, user_type: selectedUserType, incharge: '' }));
  
  // Triggering the API call when user type is changed
  fetchFilteredEmployees(selectedUserType);
};

const fetchFilteredEmployees = async (userType) => {
  try {
    const res = await ApiService.getPublic(
      `get_data.php?table=employee&asign_field=id&asign_value=DESC&authToken=`
    );

    // Filter employees based on selected user type
    const filteredEmp = res.filter((item) => {
      if (userType === 'incharge') {
        return item.user_type === 'admin' && item.status=='1'; // Admins can be assigned to incharge if user type is incharge
      }
      if (userType === 'employee') {
        return item.user_type === 'incharge' && item.status=='1'; // Employees can only be assigned to site incharges
      }
      return; // If no valid user type selected, return no options
    });

    // Update Emp state with filtered data
    setEmp(filteredEmp);
  } catch (err) {
    alertify.error("Server is down. Please fill out the form some time later.");
    console.log("Error fetching employee data:", err);
  }
};

  
  
  return (
    <div
      className="modal custom-modal custom-lg-modal fade p-20"
      id="add_companies"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header border-0">
            <div className="form-header modal-header-title text-start mb-0">
              <h4 className="mb-0">
                Add New Employee
              </h4>
            </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form onSubmit={HandleSubmit}>
            <div className="modal-body">
              <div className="row">

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-label">Name </label>
                    <input
                      type="text"
                      className={`form-control ${validation.name ? "" : "input-error"
                        }`}
                      placeholder="Enter Name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-label">Date Of Birth </label>
                    <input
                      type="date"
                      className={`form-control ${validation.date_of_birth ? "" : "input-error"
                        }`}
                      value={formData.date_of_birth}
                      onChange={(e) => setFormData({ ...formData, date_of_birth: e.target.value })}
                    />
                  </div>
                </div>

                 <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label>Employee Type</label>
                    <select
                      className={`form-select ${validation.emp_type ? "" : "input-error"}`}
                      value={formData.emp_type}
                      onChange={(e) => setFormData({ ...formData, emp_type: e.target.value })}
                    >
                      <option value="">Select Employee Type</option>
                      <option value="permenent">Permenent</option>
                      <option value="contract">Contract</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label>User Type</label>
                    <select
                      className={`form-select ${validation.user_type ? '' : 'input-error'}`}
                      value={formData.user_type}
                      onChange={handleUserTypeChange}
                    >
                      <option value="">Select User Type</option>
                      <option value="incharge">Site Incharge</option>
                      <option value="employee">Employee</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label>Incharge</label>
                    <select
                      className={`form-select ${validation.incharge ? '' : 'input-error'}`}
                      value={formData.incharge}
                      onChange={(e) => setFormData({ ...formData, incharge: e.target.value })}
                      disabled={formData.user_type === 'admin' || formData.user_type ==""}
                    >
                      <option value="">Select Incharge</option>
                      {Emp&&Emp.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>


                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label>Location</label>
                    <select
                      className={`form-select ${validation.location ? '' : 'input-error'}`}
                      value={formData.location}
                      onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                    >
                      <option value="">Select Location</option>
                      {LocationData&&LocationData.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label>Blood Group</label>
                    <select
                      className={`form-select ${validation.blood_group ? "" : "input-error"}`}
                      value={formData.blood_group}
                      onChange={(e) => setFormData({ ...formData, blood_group: e.target.value })}
                    >
                      <option value="">Select Blood Group</option>
                      <option value="A+">A+</option>
                      <option value="A1+">A1+</option>
                      <option value="O+">O+</option>
                      <option value="B+">B+</option>
                      <option value="AB+">AB+</option>
                      <option value="A-">A-</option>
                      <option value="O-">O-</option>
                      <option value="B-">B-</option>
                      <option value="AB-">AB-</option>
                    </select>

                  </div>
                </div>

                {/* <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label>Department</label>
                    <select
                      className={`form-select ${validation.department ? "" : "input-error"}`}
                      value={formData.department}
                      onChange={(e) => setFormData({ ...formData, department: e.target.value })}
                    >
                      <option value="">Select Employee Department</option>
                      <option value="admin">Admin</option>
                      <option value="quality">Quality</option>
                      <option value="production">Production</option>
                      <option value="production_incahrge">Production Incharge</option>
                    </select>
                  </div>
                </div> */}

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="mb-2">Phone Number</label>
                    <input
                      className={`form-control ${validation.mobile_no ? "" : "input-error"
                        }`}
                      id="relationship"
                      name="relationship"
                      type="number"
                      placeholder="Phone Number"
                      value={formData.mobile_no}
                      onChange={(e) => setFormData({ ...formData, mobile_no: e.target.value })}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-control-label">Password</label>
                    <div className="pass-group modal-password-field">
                      <input

                        type={eye ? "password" : "text"}
                        className={`form-control pass-input ${validation.password ? "" : "input-error"
                          }`}
                        placeholder="Password"
                        value={formData.password}
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                      />

                      <span
                        onClick={onEyeClick}
                        className={`fas toggle-password ${eye ? "fa-eye-slash" : "fa-eye"
                          }`}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-label">Date Of Joining </label>
                    <input
                      type="date"
                      className={`form-control ${validation.doj ? "" : "input-error"
                        }`}
                      value={formData.doj}
                      onChange={(e) => setFormData({ ...formData, doj: e.target.value })}
                    />
                  </div>
                </div>

                {/* <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-label">In Time</label>
                    <input
                      type="time"
                      className={`form-control ${validation.shift_in ? "" : "input-error"
                        }`}
                      value={formData.shift_in}
                      onChange={(e) => setFormData({ ...formData, shift_in: e.target.value })}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-label">Out Time</label>
                    <input
                      type="time"
                      className={`form-control ${validation.shift_out ? "" : "input-error"
                        }`}
                      value={formData.shift_out}
                      onChange={(e) => setFormData({ ...formData, shift_out: e.target.value })}
                    />
                  </div>
                </div> */}

                {/* <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label>Stay</label>

                    <select
                      className={`form-select ${validation.stay ? "" : "input-error"}`}
                      value={formData.stay}
                      onChange={(e) => setFormData({ ...formData, stay: e.target.value })}
                    >
                      <option value="">Select Stay</option>
                      <option value="instay">In Stay</option>
                      <option value="outstay">Out Stay</option>
                    </select>

                  </div>
                </div> */}

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="mb-2">Salary</label>
                    <input
                      className={`form-control ${validation.salary ? "" : "input-error"
                        }`}
                      id="salary"
                      name="salary"
                      type="number"
                      placeholder="Enter Salary"
                      value={formData.salary}
                      onChange={(e) => setFormData({ ...formData, salary: e.target.value })}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="mb-2">Emergency Contact Person</label>
                    <input
                      className={`form-control ${validation.con_person ? "" : "input-error"
                        }`}
                      id="con_person"
                      name="con_person"
                      type="text"
                      placeholder="Emergency Contact Person"
                      value={formData.con_person}
                      onChange={(e) => setFormData({ ...formData, con_person: e.target.value })}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="mb-2">Emergency Contact Number</label>
                    <input
                      className={`form-control ${validation.cont_no ? "" : "input-error"
                        }`}
                      id="cont_no"
                      name="cont_no"
                      type="number"
                      placeholder="Emergency Contact Number"
                      value={formData.cont_no}
                      onChange={(e) => setFormData({ ...formData, cont_no: e.target.value })}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="mb-2">Emergency Contact Relationship</label>
                    <input
                      className={`form-control ${validation.relationship ? "" : "input-error"
                        }`}
                      type="text"
                      placeholder="Emergency Contact Relationship"
                      value={formData.relationship}
                      onChange={(e) => setFormData({ ...formData, relationship: e.target.value })}
                    />
                  </div>
                </div>

                {/* <div className="col-md-12">
                  <div className="d-flex align-items-center mb-3">
                    <h6 className="mb-0">Status</h6>
                    <div className="status-toggle">
                      <input
                        id="access-trail"
                        className="check"
                        type="checkbox"
                        checked={formData.status == "1"}
                        onChange={(e) => setFormData({ ...formData, status: e.target.checked?"1":"0" })}
                      />
                      <label
                        htmlFor="access-trail"
                        className="checktoggle checkbox-bg"
                      >
                        checkbox
                      </label>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-back cancel-btn me-2"
                ref={cancelBtnRef}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary paid-continue-btn"
              >
                Add New
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Addcompany;


Addcompany.propTypes = {
  fetchEmployees: PropTypes.func.isRequired,
  Data: PropTypes.array.isRequired,
};